module.exports = __webpack_public_path__ + "static/media/logo-tanta.2ed38ef6.svg";